import styled from 'styled-components';
import {
  MOBILE_NAV_HEIGHT,
  MOBILE_NAV_TRANSITION_FUNCTION,
  MOBILE_NAV_TRANSITION_SPEED,
} from 'common/consts/navigation';
import { media } from 'designsystem/index';

const ContentWrapper = styled.div`
  position: relative;
  top: 0;
  transition: top ${MOBILE_NAV_TRANSITION_SPEED} ${MOBILE_NAV_TRANSITION_FUNCTION};
  
  ${({ mobileNavOpened }) => (mobileNavOpened ? `
    top: ${MOBILE_NAV_HEIGHT};
  ` : 0)};
  
  ${media.desktop`
    top: 0;
  `};
`;

export default ContentWrapper;



// WEBPACK FOOTER //
// ./src/blocks/NavigationAwarePageContent/ContentWrapper.jsx